var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28128 13.9039L2.35315 13.9719L2.28128 13.9039C1.9698 14.2331 1.46371 14.236 1.14869 13.9103L1.14867 13.9103C0.831251 13.5823 0.828183 13.0458 1.1419 12.714L6.0189 7.55936L6.08467 7.48985L6.01812 7.42109L1.08312 2.32206C0.765656 1.99391 0.762636 1.45742 1.07631 1.12589L1.07635 1.12585C1.38765 0.796509 1.89371 0.793617 2.2089 1.11944L2.20892 1.11946L7.78629 6.88216C7.94443 7.04568 8.0249 7.26146 8.02614 7.47884C8.02737 7.69625 7.94918 7.91293 7.79293 8.07817C7.79293 8.07818 7.79292 8.07818 7.79292 8.07819L2.28128 13.9039Z",
    fill: "#4D525C",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d1b49c5592a23eb1a93fe78e0de8f015.svg";
export { ForwardRef as ReactComponent };